import React from "react";
import PriceHero from "./PriceHero";
import PriceCard from "./PriceCard";
import Price_faq from "./Price_faq";
import Our_Plan from "./Our_Plan";
import Adon_Price from "./Adon_Price";
import BundlePackage from "./BundlePackage";
import EnterPrise_Customer from "./EnterPrise_Customer";
import Payment_Method from "./Payment_Method";
import WhyChoose from "../NavSection_Dropdown/Products/Whatsapp Marketing/WhyChoose";


const PricingPage = () => {
    return (
        <>
            <PriceHero />
            <PriceCard />
            <Our_Plan />
            <Adon_Price />
            <BundlePackage />
            <EnterPrise_Customer />
            <Payment_Method />
            <WhyChoose />
            <Price_faq />
        </>
    );
};
export default PricingPage